import { useMemo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useAuthRedirect } from '@sandtech-hub-monorepo/ui-auth-kit';
import { AppRoutes } from './routes';
import { generateRoutesFromDefinitionList } from './util';
import { GuardedRoutes } from './guardedRoute';

export const AppRouter = () => {
  useAuthRedirect();

  const routeList = useMemo(() => {
    const publicRoutes = generateRoutesFromDefinitionList(AppRoutes.public);
    const privateRoutes = generateRoutesFromDefinitionList(AppRoutes.private);

    return { publicRoutes, privateRoutes };
  }, []);
  return (
    <Routes>
      <Route element={<GuardedRoutes />}>{routeList.privateRoutes}</Route>
      ...{routeList.publicRoutes}
    </Routes>
  );
};
